
import DownloadCSVCmp from '../components/DownloadCSVCmp.js';

const { connect } = require('react-redux');

const { checkToken  } = require('../actions/loginAction')
const { getEmisiones, downloadCSV, getEntidades } = require('../actions/homeAction')

const mapStateToProps = (state) => {
    return{
      emisionesStatus: state.homeReducer.emisionesStatus,
      emisiones: state.homeReducer.emisiones,
      status: state.loginReducer.status,
      csvFile: state.homeReducer.csvFile,
      csvFileStatus: state.homeReducer.csvFileStatus,
      entidades: state.homeReducer.entidades,
      entidadesStatus: state.homeReducer.entidadesStatus
    }
};

const mapDispatchToProps = dispatch => ({
  checkToken: () => {
    dispatch(checkToken());
  },
  getEmisiones: (payload) => {
    dispatch(getEmisiones(payload));
  },
  downloadCSV: (payload) => {
    dispatch(downloadCSV(payload))
  },
  getEntidades: () => {
    dispatch(getEntidades());
  }
 });

export default connect(mapStateToProps, mapDispatchToProps)(DownloadCSVCmp);
